<template>
	<div id="metode-pembayaran">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Pembayaran</li>
      <li class="active">List Metode Pembayaran</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">List Metode Pembayaran</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createMetodePembayaran()"><span class="fa fa-plus"></span> Tambah Metode Pembayaran</button>
							<button type="button" class="btn btn-success btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Action <span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li><a @click="updateAllMetodePembayaranStatus(status.PUBLISH)">Publish All</a></li>
								<li><a @click="updateAllMetodePembayaranStatus(status.UNPUBLISH)">Unpublish All</a></li>
							</ul>
            </div>
            <h4 class="panel-title">List Metode Pembayaran</h4>
          </div>
          <div class="panel-body">
            <app-datatable
							:items="metodePembayaranList"
							:has-action="true"
							:headers="headers"
							:has-custom-pagination="true"
							:has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-items="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              v-on:selected="selectedRow = $event"
							v-on:dblClicked="updateMetodePembayaran()"
							v-on:deleted="deleteMetodePembayaran($event)"
							v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
						/>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import SalesService from '@/services/sales.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'

export default {
	name: 'metode-pembayaran',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			metodePembayaranList: [],
			isLoading: false,
			selectedRow: null,
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Nama', 'Tipe', 'Atas Nama', 'Nomor Rekening', 'Status'],
			headersKey: ['bankName', 'type', 'accountName', 'accountNumber', 'status'] // camel case for matching search with API
		}
	},
	mounted: function () {
		this.fetchData()
	},
	watch: {
		pagination: function () {
			this.fetchData()
		},
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}

			this.isLoading = true

			SalesService.getMetodePembayaranList(pagination, search, function (result) {
				context.metodePembayaranList = []
				context.isLoading = false

				if (result.success) {
					result.data.forEach(function (content) {
						var row = {
							id: content.id,
							data: [
								content.bank_name,
                content.type,
								content.account_name,
								content.account_number,
								content.status,
							]
						}
						context.pagination.totalPages = content.page
						context.metodePembayaranList.push(row)
					})
				} else {
					alert('Terjadi Kesalahan : ' + result.message)
				}
			})
		},
		createMetodePembayaran: function () {
			this.$router.push({ path: '/metode-pembayaran/form' })
		},
		updateMetodePembayaran: function () {
			var metodePembayaranId = this.selectedRow.id
			this.$router.push({ path: '/metode-pembayaran/form', query: { id: metodePembayaranId } })
		},
		updateAllMetodePembayaranStatus: function (status) {
			var context = this
			var confirmed = window.confirm("Apakah anda yakin akan mengupdate semua status metode pembayaran?")

			if (confirmed) {
				this.isLoading = true
				SalesService.updateAllMetodePembayaranStatus(status, function (result) {
					context.isLoading = false
					if (result.success) {
						alert('Data Terupdate')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		},
		deleteMetodePembayaran: function (metodePembayaran) {
			var context = this
			var metodePembayaranId = metodePembayaran.id
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")

			if (confirmed) {
				this.isLoading = true
				SalesService.deleteMetodePembayaran(metodePembayaranId, function (result) {
					context.isLoading = false
					if (result.success) {
						alert('Data Terhapus')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// MetodePembayaran.vue?e87f858e